import axios, { AxiosError } from "axios";
import CommunicationCategoryType from "../../enums/CommunicationCategoryType";
const TenantEmailSettingsResource = {
    fetchEmailSettings(tenantId, resultFunc, errorFunc, finallyFunc) {
        axios.get(`/admin/v1/tenants/${tenantId}/settings-email`)
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
    deleteEmailSender(tenantId, communicationCategory, errorFunc, finallyFunc) {
        axios.delete(`/admin/v1/tenants/${tenantId}/settings-email/${communicationCategory.key}`)
            .catch(errorFunc)
            .finally(finallyFunc);
    },
    updateEmailSender(tenantId, communicationCategory, sender, resultFunc, errorFunc, finallyFunc) {
        axios.post(`/admin/v1/tenants/${tenantId}/settings-email/${communicationCategory.key}`, sender)
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    }
};
export default TenantEmailSettingsResource;
